export const tooltips: { [key: string]: string} = {
    fullName: "Your name should not contain any numbers or punctuation apart from an apostrophe (') or hyphen (-).",
    fullNameApplication: `Please check your name is correct,
        you may enter any middle names that you've not previously included into the first name field.`,
    email: `We'll use this email address for all correspondence with you. When you click
     'Agree and continue' at the end of this section we'll send you instructions
      on how to return to this form should you need to take a break.`,
    dob: `To get quotes with Annuity Ready you must be at least 55 years of age.
        For information regarding earlier retirement please visit
        <a href='https://www.moneyhelper.org.uk/en/pensions-and-retirement' target='_new'>MoneyHelper</a>.<br><br>
        The maximum age you can quote or apply for an annuity with Annuity Ready is 84 years 9 months.`,
    postcode: `Please provide the postcode of your current permanent UK residential address.
        If you are resident abroad, we will be unable to help you. However,
        if you would still like to look into purchasing a lifetime annuity, please visit
        <a href='https://www.moneyhelper.org.uk/en/pensions-and-retirement' target='_new'>MoneyHelper</a>.`,
    telephone: "If you provide us with your telephone number we may use it to contact you regarding your quote.",
};
